<template>
  <v-dialog
    title="Upload Content"
    :visible.sync="dialogVisible"
    :scrollbar="false"
    width="auto"
    @closed="onClosed"
  >
    <div class="el-uploader-wrap">
      <div class="el-uploader-inner">
        <div class="el-uploader">
          <input
            class="upload-input"
            ref="upload"
            type="file"
            accept=".csv,.CSV"
            @change="handleChange"
          />
          <div @click="$refs.upload.click()">
            <el-input
              disabled
              :value="fileName"
              placeholder="Please select file"
            >
              <el-button class="append-button" slot="append" type="text">
                {{ buttonLabel }}
              </el-button>
            </el-input>
          </div>
        </div>
        <el-button type="primary" @click="handleSubmit" :disabled="disabled">
          Upload
        </el-button>
      </div>
      <div class="upload-progress">
        <el-progress
          v-if="showProgress"
          :percentage="percentage"
          :status="status"
          :show-text="false"
          :stroke-width="3"
        />
      </div>
    </div>
  </v-dialog>
</template>
<script>
import downloadjs from "downloadjs";
export default {
  name: "upload-content-dialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      selectFile: null,
      showProgress: false,
      percentage: 0,
      status: "success",
      disabled: true,
    };
  },
  computed: {
    buttonLabel() {
      return this.selectFile ? "Reselect file" : "Select File";
    },
    fileName() {
      return this.selectFile ? this.selectFile.name : "";
    },
  },
  watch: {
    visible(value) {
      this.dialogVisible = value;
    },
  },
  methods: {
    onClosed() {
      this.selectFile = null;
      this.percentage = 0;
      this.showProgress = false;
      this.status = "success";
      this.disabled = true;
      this.$emit("update:visible", false);
    },
    handleChange(e) {
      const file = e.target.files[0];
      this.$refs.upload.value = "";
      if (!/\.(?:csv|CSV})$/i.test(file.name)) {
        this.$message.warning("Only CSV file can be uploaded");
        return;
      }
      this.showProgress = false;
      this.percentage = 0;
      this.status = "success";
      this.selectFile = file;
      this.disabled = false;
    },
    handleSubmit() {
      if (this.selectFile) {
        this.status = "success";
        this.disabled = true;
        let formData = new FormData();
        formData.append("file", this.selectFile, this.selectFile.name);
        this.axios
          .post("/content/uploadContent", formData, {
            header: {
              headers: { "Content-Type": "multipart/form-data" },
            },
            onUploadProgress: (e) => {
              if (e.lengthComputable) {
                this.showProgress = true;
                this.percentage = ((e.loaded / e.total) * 100) | 0;
              }
            },
          })
          .then(({ code, msg, data }) => {
            if (code == 200) {
              this.showProgress = false;
              this.$message.success("Upload template successfully");
              setTimeout(() => {
                this.$emit("success");
                this.$emit("update:visible", false);
              }, 1000);
            } else {
              this.disabled = false;
              this.$message.error(msg);
              const { content, fileName} = data;
              downloadjs(content, fileName, "text/csv");
              this.status = "exception";
            }
          });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .el-dialog__body {
    padding: 10px 15px 15px !important;
  }
  .el-dialog__footer {
    padding: 0;
  }
}
.el-uploader-wrap {
  .el-uploader-inner {
    display: flex;
    justify-content: center;
    margin-bottom: 5px;
  }
}
.el-uploader {
  position: relative;
  margin-right: 10px;
  .upload-input {
    position: absolute;
    width: 0;
    height: 0;
    opacity: 0;
    cursor: pointer;
    -webkit-appearance: none;
    display: none;
  }
  .el-input + .el-button {
    margin-left: 5px;
  }
  .el-input {
    ::v-deep {
      .el-input__inner {
        cursor: pointer;
        background: none;
        border-right-width: 0;
        color: #606266;
      }
      .el-input-group__append {
        background: none;
      }
    }
  }
  .append-button {
    padding-right: 10px;
    color: $theme-color;
  }
}
.upload-progress {
  height: 8px;
}
</style>
